
/**
 * 
 * @hidden
 */
export enum ColumnTypes {

    /**
     * 
     */
    Standard = 1,

    /**
     * 
     */
    Button = 2,

    /**
     * 
     */
    Submitbutton = 3,

    /**
     * 
     */
    Group = 4,

    /**
     * 
     */
    ColumnSelector = 5,
}
